import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SiteManagerComponent } from '../site-manager/site-manager.component';
import { NavigationManagerService } from 'src/app/shared/services/navigation-manager.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';

export interface IMasterCredential {
  name: string;
  badgeId: string;
  status: string;
  access: string;
  description: string;
  assignTo: string;
}

@Component({
  selector: 'app-master-credential-detail',
  templateUrl: './master-credential-detail.component.html',
  styleUrls: ['./master-credential-detail.component.scss'],
})
export class MasterCredentialDetailComponent {
  @Input() selectedSite: any;
  @Input() selectedMasterCredential: IMasterCredential | null = null;
  @Input() navigateToEditMasterCredential: any;
  isPMU = false;

  constructor(
    public dialogRef: MatDialogRef<SiteManagerComponent>,
    private navigationManagerService: NavigationManagerService,
    private stateManagementService: StateManagementService
  ) {
    const user = this.stateManagementService.getUser();
    this.isPMU = user?.userType === userTypeResponse[2];
  }

  navigateBack(): void {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.MASTER_CREDENTIAL
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onActivityClick(): void {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.ACTIVITY);
  }

  onEditDescription(): void {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.EDIT_MASTER_CREDENTIAL
    );
  }
}
